import { useState, type FormEvent } from 'react';
import { postForm } from '@/components/base/postForm';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/dagmi8jep053ijub2drg';
const SUCCESS_MSG = '已收到你的留言，我们会尽快回复。感谢你对每日新料的信任！';

const topicOptions = [
  '爆料线索投稿',
  '内容更正反馈',
  '商务合作咨询',
  '使用问题反馈',
  '其他',
];

export default function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    setStatus('idle');
    const result = await postForm(SUBMIT_ADDR, form, SUCCESS_MSG);
    if (result.ok) {
      setStatus('success');
      setMessage(result.message);
      form.reset();
    } else {
      setStatus('error');
      setMessage(result.message);
    }
  }

  const fieldBase =
    'w-full rounded-lg border border-background-200 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200';

  return (
    <form id="contact-form" data-readdy-form="contact-form" onSubmit={handleSubmit} noValidate>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label htmlFor="contact-name" className="mb-1.5 block text-sm font-medium text-foreground-800">
            你的称呼
          </label>
          <input id="contact-name" type="text" name="name" required placeholder="例如：小明" className={fieldBase} />
        </div>
        <div>
          <label htmlFor="contact-email" className="mb-1.5 block text-sm font-medium text-foreground-800">
            联系邮箱
          </label>
          <input id="contact-email" type="email" name="email" required autoComplete="email" placeholder="you@example.com" className={fieldBase} />
        </div>
        <div className="sm:col-span-2">
          <label htmlFor="contact-topic" className="mb-1.5 block text-sm font-medium text-foreground-800">
            留言主题
          </label>
          <select id="contact-topic" name="topic" className={fieldBase} defaultValue={topicOptions[0]}>
            {topicOptions.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </select>
        </div>
        <div className="sm:col-span-2">
          <label htmlFor="contact-message" className="mb-1.5 block text-sm font-medium text-foreground-800">
            留言内容
          </label>
          <textarea
            id="contact-message"
            name="message"
            required
            rows={5}
            maxLength={500}
            placeholder="请描述你想反馈的内容、需要更正的信息或合作意向……"
            className={`${fieldBase} resize-y`}
          />
          <p className="mt-1 text-right text-xs text-foreground-400">最多 500 字</p>
        </div>
      </div>

      {/* 反垃圾蜜罐 */}
      <input type="text" name="website_alt" autoComplete="off" tabIndex={-1} aria-hidden="true" readOnly />

      <button
        type="submit"
        className="mt-2 inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300"
      >
        <i className="ri-send-plane-line" aria-hidden="true" />
        提交留言
      </button>

      {status === 'success' && (
        <p role="status" className="mt-3 flex items-center gap-2 text-sm text-accent-700">
          <i className="ri-checkbox-circle-line text-lg" aria-hidden="true" />
          {message}
        </p>
      )}
      {status === 'error' && (
        <p role="alert" className="mt-3 flex items-center gap-2 text-sm text-primary-700">
          <i className="ri-error-warning-line text-lg" aria-hidden="true" />
          {message}
        </p>
      )}
    </form>
  );
}